import React from 'react';

const Checkout = () => {
     return (
          <div className="h-1/2">
               <h2 className="font-bigilla text-9xl">This is Checkout</h2>
               <p className="font-inter text-9xl">Here are Details</p>
          </div>
     );
};

export default Checkout;